export const DELETE_UA_VIEW_NAME = "delete_user_analytics_view";
export const DELETE_UA_VIEW_DESC = `Deletes a User Analytics view (GA4 view saved under a User Analytics project).

Use when the user explicitly asks to remove or clean up a saved User Analytics view. Confirm the target by showing its name/description before running the mutation.

Input:
- 'id' (required): User Analytics view ID. Obtainable from previous listing/update operations or by decoding the UI URL.

Output:
- Returns the deleted view ID, the last known name/description, and workspace/project information plus 'viewUrl'/'viewPath' so the UI can link back to the list.

Notes:
- Write operation; always run through confirmation UI.
- If the ID is invalid or the view no longer exists, return an error so the user can refresh the list.`;
